<ng-container *ngIf="activeLayout == layoutTypes.APP">
  <top-banner *ngIf="topBannerState$ | async"></top-banner>
  <div class="app-wrapper">
    <sidebar-mobile-button></sidebar-mobile-button>
    <div class="app-navbar">
      <sidebar-menu></sidebar-menu>
    </div>
    <div class="app-container">
      <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
    </div>
  </div>
  <support-widget *ngIf="currentUser?.id"></support-widget>
</ng-container>

<div class="registration-wrapper registration-blank-wrapper" *ngIf="activeLayout == layoutTypes.REGISTRATION_BLANK">
  <div class="registration-container">
    <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
  </div>
</div>

<div class="registration-empty-wrapper" *ngIf="activeLayout == layoutTypes.REGISTRATION_EMPTY">
  <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
</div>

<div class="registration-simple-wrapper" *ngIf="activeLayout == layoutTypes.REGISTRATION_SIMPLE">
  <registration-simple-header></registration-simple-header>
  <div class="registration-simple-container">
    <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
  </div>
  <registration-footer [isHideNavigation]="true"></registration-footer>
</div>

<div class="app-wrapper" *ngIf="activeLayout == layoutTypes.ERRORS">
  <div class="app-navbar"></div>
  <div class="app-container">
    <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
  </div>
  <div class="app-sidebar no-top-menu"></div>
</div>

<div class="invisible" *ngIf="activeLayout == layoutTypes.BLANK">
  <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
</div>

<div class="" *ngIf="activeLayout == layoutTypes.ADMIN">
  <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
</div>

<div *ngIf="activeLayout == layoutTypes.SHARED_RECORD">
  <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
</div>

<div *ngIf="activeLayout == layoutTypes.EMBED_RECORD" class="h-full">
  <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
</div>

<ng-template #routerOutlet>
  <router-outlet></router-outlet>
</ng-template>

<div class="toaster">
  <ng-container #toaster></ng-container>
</div>
